import React, { useRef } from "react";
import './css/Navbar.css';
import me from './images/me-nobg.png';



const Navbar = ({educationRef, experienceRef, skillsRef, contactRef, introRef}) => {

    const scrollToSection = (sectionRef) => {
        if (sectionRef && sectionRef.current) {
            sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    return( 
        <nav className="bg-[#ffd739] border-b border-gray-200 max-w-automr-auto ml-auto">
          <div className="items-center justify-center hidden md:flex w-full md:w-auto md:order-1 p-4 ">
            <ul className="md:flex-row md:flex md:space-x-20 md:p-0 items-center ">
                <li>
                    <a href="/" onClick={(e) =>{
                        e.preventDefault();
                        scrollToSection(educationRef)

                    }}>Education</a>
                </li>
                <li><a href="/" onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(experienceRef)
                }}>Experience</a></li>
                <li>
                <a href="/" onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(introRef)
                }}>
                    <img src={me} className="img-nav w-10 rounded-full" alt="Me"/>
                </a>
                </li>
                <li>
                <a href="/" onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(skillsRef)
                }}>Skills</a>
                </li>
                <li>
                <a href="/" onClick={(e) => {
                    e.preventDefault();
                    scrollToSection(contactRef);
                }}>Contact</a>
                </li>
            </ul>
          </div>
        </nav>
    );
}

export default Navbar;